import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';
import Progress from 'components/common/Progress';
import Button from 'components/common/Button';
import IconPen from 'components/icons/IconPen';

import {
  fetchPatientInsurance,
  checkPatientInsuranceEligibility,
} from 'redux/modules/patientsInsurance';

import InsuranceViewTable from './InsuranceViewTable';

const styles = () => ({
  action: {
    '&:first-child': {
      position: 'absolute',
      left: 14,
      top: 8,
    },
  },
  iconPen: {
    width: 16,
    height: 16,
    marginRight: 8,
  },
});

const InsuranceViewDialog = ({
  open,
  onClose,
  onEditButtonClick,
  actions,
  appInfo,
  classes,
  ...otherProps
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    onEnter={() => {
      if (!otherProps['Insurance ID']) {
        actions.fetchPatientInsurance({
          ID: otherProps.ID,
        });
      }
    }}
    maxWidth="sm"
  >
    <DialogTitle onCloseClick={onClose}>
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        {otherProps['Payer Name']}
      </Typography>
    </DialogTitle>
    <DialogContent
      withScrollbars
      disableGutters
      fullHeight
    >
      {(!otherProps['Insurance ID']) ? (
        <Progress />
      ) : (
        <InsuranceViewTable {...otherProps} />
      )}
    </DialogContent>
    <DialogActions
      {...(otherProps['Insurance Info']
        && otherProps['Insurance Info']['Change Info']
        && otherProps['Insurance Info']['Change Info']['Is Eligibility']) ? { classes: {
          action: classes.action,
        } } : {}}
    >
      {(otherProps['Insurance Info']
        && otherProps['Insurance Info']['Change Info']
        && otherProps['Insurance Info']['Change Info']['Is Eligibility']) &&
        <div>
          <Button
            onClick={() => {
              actions.checkPatientInsuranceEligibility({
                'Patient ID': otherProps['User Record Number'],
                'Insurance ID': otherProps.ID,
              });
            }}
            disabled={otherProps['Checking Eligibility'] || ['demo', 'clients'].indexOf(appInfo['APP NAME']) !== -1}
            color="primary"
            underline
          >
            Check Eligibility
          </Button>
          {otherProps['Checking Eligibility'] &&
            <Progress />
          }
        </div>
      }
      <Button
        onClick={onEditButtonClick}
        variant="raised"
      >
        <IconPen className={classes.iconPen} />
        Edit
      </Button>
    </DialogActions>
  </Dialog>
);

InsuranceViewDialog.propTypes = {
  'Insurance Info': PropTypes.shape({
    'Payer Name': PropTypes.string.isRequired,
  }),
  'User Record Number': PropTypes.number,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onEditButtonClick: PropTypes.func,
  actions: PropTypes.shape({
    checkPatientInsuranceEligibility: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    action: PropTypes.string.isRequired,
    iconPen: PropTypes.string.isRequired,
  }).isRequired,
};

InsuranceViewDialog.defaultProps = {
  'User Record Number': null,
  open: false,
  onClose: () => {},
  onEditButtonClick: () => {},
  'Insurance Info': null,
};

const mapStateToProps = store => ({
  appInfo: store.appInfo,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchPatientInsurance,
    checkPatientInsuranceEligibility,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(InsuranceViewDialog),
);



// WEBPACK FOOTER //
// ./src/components/patient/InsuranceViewDialog/InsuranceViewDialog.js